import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

/**
 * Enchanted Rose — Beauty and the Beast
 * A rose-like fractal enclosed in a translucent glass sphere.
 * spiral3D forms the swirling petal structure, julia3D adds complex
 * internal folding, and sinusoidal3D provides organic leaf-like forms.
 * Based on the deluksic flame descriptor with tuned render settings
 * for a dramatic enchanted glow.
 */
export const example34 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'unknown',
    name: 'Enchanted Rose',
    description:
      'Beauty and the Beast A rose-like fractal enclosed in a translucent glass sphere. spiral3D forms the swirling petal structure, julia3D adds complex internal folding, and sinusoidal3D provides organic leaf-like forms. Based on the deluksic flame descriptor with tuned render settings for a dramatic enchanted glow.',
  },
  renderSettings: {
    dimensions: 3,
    exposure: -2.7,
    skipIters: 20,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    pointInitMode: 'pointInitUnitBall',
    vibrancy: 1.05,
    contrast: 5.45,
    gamma: 3.85,
    depthColorPower: 0.0,
    lightDirection: [-0.5, 0.5, -1],
    lightPower: 0.1,
    highlightPower: 1.29,
    densityEstimationQuality: 0.66,
    estimatorCurve: 0.35,
    paletteMode: 0,
    palettePhase: 0,
    paletteSpeed: 0.5,
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 6.501777343750011,
      phi: 3.1080379660897943,
      radius: 3.242708697088002,
      target: [0, 0, 0],
      fov: 60,
    },
  },
  transforms: {
    [tid('3d_rose_a')]: {
      probability: 0.5,
      preAffine: {
        a: 0.8,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.8,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.8,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.1, y: 0.3 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_rose_a_v0')]: { type: 'spiral3D', weight: 1 },
      },
    },
    [tid('3d_rose_b')]: {
      probability: 0.3,
      preAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.2, y: 0.1 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_rose_b_v0')]: { type: 'julia3D', weight: 1 },
        [vid('3d_rose_b_v1')]: { type: 'linear3D', weight: 0.4 },
      },
    },
    [tid('3d_rose_c')]: {
      probability: 0.2,
      preAffine: {
        a: 0.5,
        b: 0,
        c: 0,
        d: 0.1,
        e: 0,
        f: 0.5,
        g: 0,
        h: 0.1,
        i: 0,
        j: 0,
        k: 0.5,
        l: 0.1,
      },
      postAffine: {
        a: 0,
        b: -1,
        c: 0,
        d: 0,
        e: 1,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.5, y: -0.2 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_rose_c_v0')]: { type: 'julia3D', weight: 0.7 },
        [vid('3d_rose_c_v1')]: { type: 'sinusoidal3D', weight: 0.3 },
      },
    },
  },
})
